import React, { useContext, useEffect, useState, useRef } from "react";
import closeIcon from "../../Assets/popup/cross-square.svg";
import {
  DateRangePicker,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Select,
  SelectItem,
  Textarea,
} from "@nextui-org/react";
import { Controller, useForm } from "react-hook-form";
import calendar from "../../Assets/create-frond/calendar.svg";
import up from "../../Assets/create-frond/up.svg";
import euro from "../../Assets/create-frond/euro.svg";
import RemoveComponent from "../../pages/CreateAFrond/RemoveComponent";
import { WithContext as ReactTags } from "react-tag-input";
import "./modalStyle.css";
import { parseDate } from "@internationalized/date";
import { AuthContext } from "Context/AuthContext";
import { toast } from "react-toastify";
import axios from "axios";
import { PopUpContext } from "Context/PopUpContext";
import useSize from "hooks/useSize";
import { API_BASE_URL } from "../../config/apiConfig";

const EditDetailsModal = ({
  isOpen,
  onClose,
  frondData,
  getFrondData,
  isModalOpen,
}) => {
  const labelBudgetHtml = `Budget <span class='text-xs text-cardGrayColor'>(Optional)</span>`;
  const labelCurrencyHtml = `Currency <span class='text-xs text-cardGrayColor'>(Optional)</span>`;
  const labelDescHtml = `Description <span class='text-xs text-cardGrayColor'>(Optional)</span>`;
  const labelDateHtml = `Start Date-End Date <span class='text-xs text-cardGrayColor'>(Optional)</span>`;

  const categories = ["Home", "Event", "Escape", "Venture", "Other"];
  const [importance, setImportance] = useState(null);

  const [descLength, setDescLength] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);


  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      category: "",
      desc: "",
      dateRange: "",
      budget: "",
      currency: "",
      tags: [],
      importance: "",
    },
  });

  // currencies

  const [currenciesList, setCurrenciesList] = useState([]);

  const getCurrencies = async () => {
    try {
      const { data } = await axios.get(
        `${API_BASE_URL}/currencies`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCurrenciesList(data?.response?.data[0]);
    } catch (error) {
      toast(error?.response?.data?.message, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
  };

  useEffect(() => {
    getCurrencies();
  }, []);

  //Tags

  const [tags, setTags] = useState([]);
  const [tagError, setTagError] = useState("");
  const [tagLimit, setTagLimit] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setValue("tags", tags, { shouldValidate: true });
    if (tags.length === 10) {
      setTagLimit(true);

      setTimeout(() => {
        setTagLimit(false);
      }, 1500);
    }
  }, [tags, setValue]);

  const handleValidation = (tags) => {
    for (let tag of tags) {
      if (tag.text.length < 2 || tag.text.length > 60) {
        return "Each tag must be between 2 and 60 characters";
      }
      if (
        !/^[a-zA-Z0-9\-\_\'\"\.\,\!\@\#\$\%\^\&\*\(\)\+\=\/\\]+(\s[A-Za-z0-9\-\/\\\_\.\,\!\@\#\$\%\^\&\*\(\)\+\=]+)*$/gi.test(
          tag.text
        )
      ) {
        return "Tag may contain characters, numbers or special characters and shouldn't end with space";
      }
    }
    return true;
  };

  const handleDelete = (index, event) => {
   
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    

    if (!tags || tags.length === 0) return;
    

    if (index < 0 || index >= tags.length) return;
    

    const newTags = tags.filter((tag, i) => i !== index);
    

    setTags(newTags);
    

    setValue("tags", newTags, { shouldValidate: true });


    const validation = handleValidation(newTags);
    if (validation === true) {
      setTagError("");
    } else {
      setTagError(validation);

      setTimeout(() => {
        setTagError("");
      }, 1500);
    }
    

    if (event && event.nativeEvent) {
      event.nativeEvent.stopImmediatePropagation();
    }
  };


  const tagsInputRef = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);


  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Store original focus
      const originalFocus = Element.prototype.focus;
      
      // Override focus to be safer
      Element.prototype.focus = function(...args) {
        // Only proceed if 'this' is valid
        if (!this || typeof this !== 'object') {
          return;
        }
        
        try {
          return originalFocus.apply(this, args);
        } catch (e) {
  
          return;
        }
      };
      
      // Cleanup on unmount
      return () => {
        Element.prototype.focus = originalFocus;
      };
    }
  }, []);


  const SafeReactTags = (props) => {
    try {
      return <ReactTags {...props} />;
    } catch (e) {
      console.log("ReactTags error:", e);
      return null;
    }
  };


  const CustomRemoveComponent = ({ onRemove, index }) => (
    <span 
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        safeHandleDelete(index, e);
      }}
      className="cursor-pointer ml-1 text-white hover:text-gray-200"
      style={{ fontSize: '14px' }}
    >
      ×
    </span>
  );


const mountedRef = useRef(true);

useEffect(() => {
  return () => {
    mountedRef.current = false;
  };
}, []);


useEffect(() => {
  if (frondData) {
    console.log("frondData.editTags:", frondData.editTags);
    console.log("frondData.editId:", frondData.editId);
    
    setValue("title", frondData.editTitle || "");
    setValue("category", frondData.editCategory || "");
    setValue("desc", frondData.editDesc || "");
    setValue("budget", frondData.editBudget || "");
    setValue("currency", frondData.editCurrecy || "");
    setValue("importance", frondData.editImportance || "");
    setImportance(frondData.editImportance || "");

    if (frondData.editStartDate || frondData.editEndDate) {
      const dateRange = {};
      
      if (frondData.editStartDate && Array.isArray(frondData.editStartDate) && frondData.editStartDate.length === 3) {
        dateRange.start = parseDate(
          `${frondData.editStartDate[2]}-${String(frondData.editStartDate[1]).padStart(
            2,
            "0"
          )}-${String(frondData.editStartDate[0]).padStart(2, "0")}`
        );
      }
      
      if (frondData.editEndDate && Array.isArray(frondData.editEndDate) && frondData.editEndDate.length === 3) {
        dateRange.end = parseDate(
          `${frondData.editEndDate[2]}-${String(frondData.editEndDate[1]).padStart(
            2,
            "0"
          )}-${String(frondData.editEndDate[0]).padStart(2, "0")}`
        );
      }
      
      if (Object.keys(dateRange).length > 0) {
        setValue("dateRange", dateRange);
      }
    }

    // FIXED: Ensure all tag IDs are strings
    if (Array.isArray(frondData.editTags)) {
      let tagCounter = 0;
      const processedTags = frondData.editTags
        .map((tag) => {
          tagCounter++;
          // Handle both string tags and object tags
          if (typeof tag === 'string' && tag.trim() !== '') {
            return {
              id: String(`existing-tag-${tagCounter}-${Date.now()}`), // Ensure ID is string
              text: String(tag.trim()), // Ensure text is string
              className: ''
            };
          } else if (tag && typeof tag === 'object') {
            const tagText = tag.name?.en || tag.text || tag.name || tag.id || '';
            if (tagText && String(tagText).trim() !== '') {
              return {
                id: String(tag.id || `existing-tag-${tagCounter}-${Date.now()}`), 
                text: String(tagText).trim(), 
                className: String(tag.className || '') 
              };
            }
          }
          return null;
        })
        .filter((tag) => tag !== null && tag.text && String(tag.text).trim() !== '');

      console.log("Setting processedTags:", processedTags);
      
      // Set both form value and state
      setValue("tags", processedTags);
      setTags(processedTags);
    } else {
      // Reset to empty arrays
      setValue("tags", []);
      setTags([]);
    }

    if (frondData.editDesc) {
      setDescLength(frondData.editDesc.length);
    }
  }
}, [frondData, setValue]);

const handleAddition = (tag) => {
  // Create a new tag object with proper structure - ensure all values are strings
  const newTag = {
    id: String(tag.id || tag.text.toLowerCase().replace(/\s+/g, '-') + '-' + Date.now()),
    text: String(tag.text || ''),
    className: String(tag.className || '')
  };
  
  const newTags = [...tags, newTag];
  
  const validation = handleValidation(newTags);

  if (validation === true) {
    setTags(newTags);
    setValue("tags", newTags, { shouldValidate: true });
    setTagError("");
    setInputValue(""); // Clear input after adding
  } else {
    setTagError(validation);

    setTimeout(() => {
      setTagError("");
    }, 1500);
  }
};

// Also update safeHandleDelete to ensure we're not returning invalid tags
const safeHandleDelete = (index, e) => {
  // Prevent default and stop propagation
  if (e && e.preventDefault) e.preventDefault();
  if (e && e.stopPropagation) e.stopPropagation();
  if (e && e.nativeEvent) e.nativeEvent.stopImmediatePropagation();

  // Use functional update to ensure we're working with latest state
  setTags((prevTags) => {
    console.log("Deleting tag at index:", index);
    console.log("Current tags:", prevTags);
    
    // Skip if index is out of bounds
    if (index < 0 || index >= prevTags.length) {
      console.log("Index out of bounds, skipping deletion");
      return prevTags;
    }
    
    // Create new array without the deleted tag - ensure all remaining tags have string IDs
    const newTags = prevTags
      .filter((_, i) => i !== index)
      .map(tag => ({
        ...tag,
        id: String(tag.id), // Ensure ID remains a string
        text: String(tag.text), // Ensure text remains a string
        className: String(tag.className || '')
      }));
    
    console.log("Tags after deletion:", newTags);
    
    // Update form value with new tags
    setValue("tags", newTags, { 
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true 
    });
    
    // Validate the new tags
    const validation = handleValidation(newTags);
    if (validation === true) {
      setTagError("");
    } else {
      setTagError(validation);
      setTimeout(() => {
        setTagError("");
      }, 1500);
    }
    
    return newTags;
  });
};

  const { token } = useContext(AuthContext);

async function editFrond(reqBody) {
  console.log("=== SUBMITTING FORM ===");
  
  setIsLoading(true);
  setIsDisabled(true);
  
  // Create FormData
  const formData = new FormData();
  
  // Add _method for PUT
  formData.append('_method', 'PUT');
  
  // Add basic fields
  formData.append('title', reqBody.title);
  formData.append('category', reqBody.category);
  
  // Add dates
  if (reqBody.dateRange?.start) {
    formData.append('start_date', `${reqBody.dateRange.start.day}/${reqBody.dateRange.start.month}/${reqBody.dateRange.start.year}`);
  }
  if (reqBody.dateRange?.end) {
    formData.append('end_date', `${reqBody.dateRange.end.day}/${reqBody.dateRange.end.month}/${reqBody.dateRange.end.year}`);
  }
  
  // Add optional fields
  if (reqBody.desc) formData.append('desc', reqBody.desc);
  if (reqBody.budget) formData.append('budget', reqBody.budget);
  if (reqBody.currency) formData.append('currency', reqBody.currency);
  
 
 if (reqBody.tags && reqBody.tags.length > 0) {
    const tagsArray = reqBody.tags
      .filter(tag => tag && tag.text && tag.text.trim() !== '')
      .map(tag => tag.text.trim());
    
    console.log("tagsArray being sent:", tagsArray);
    
    if (tagsArray.length > 0) {
      tagsArray.forEach((tag, index) => {
        formData.append(`tags[${index}]`, tag);
      });
    } else {
      // Send empty tag to clear all
      formData.append('clear_tags', '1');
    }
  } else {
    formData.append('clear_tags', '1');
  }
  
  if (importance) formData.append('priority', importance);
  if (frondData.editLatitude) formData.append('latitude', frondData.editLatitude);
  if (frondData.editLongitude) formData.append('longitude', frondData.editLongitude);
  if (frondData.editLocation) formData.append('location', frondData.editLocation);
  if (frondData.editCountry) formData.append('country', frondData.editCountry);
  if (frondData.editCity) formData.append('city', frondData.editCity);

  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/frond-about/${frondData.editId}`,
      formData,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    
    console.log("API Response:", data);
    
    if (data.status === 200) {
      toast("Updates Saved", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast success-toast",
      });
      
      setIsRefreshing(true);
      
      await getFrondData();
      setTimeout(() => {
        onClose();
        reset();
        setTags([]);
        setImportance(null);
        setIsEditTitle(true);
        setTimeout(() => {
          setIsEditTitle(false);
        }, 1000);
      }, 100);
    }
  } catch (error) {
    console.error("API Error:", error);
    console.error("Error response:", error?.response?.data);
    
    const errorMessage = error?.response?.data?.errors?.tags 
      ? `Tags error: ${error.response.data.errors.tags[0]}`
      : error?.response?.data?.message || "Error updating";
      
    toast(errorMessage, {
      autoClose: 1500,
      position: "bottom-right",
      hideProgressBar: true,
      className: "rounded-4xl custom-toast error-toast",
    });
  } finally {
    setIsDisabled(false);
    setIsLoading(false);
  }
}

  const { isEditDetailsOpen, setIsEditTitle } = useContext(PopUpContext);

  const handleResize = () => {
    const scrollOutter = document.querySelector(".scroll-outter");
    const scrollInner = document.querySelector(".scroll-inner");

    if (scrollOutter && scrollInner) {
      const scrollOutterWidth = scrollOutter.offsetWidth;
      const scrollInnerWidth = scrollInner.offsetWidth;
      scrollOutter.style.width = `calc(100% + ${
        scrollOutterWidth - scrollInnerWidth
      }px)`;
    }
  };
// useEffect(() => {
//   if (frondData) {
//     console.log("frondData.editTags:", frondData.editTags);
//     console.log("frondData.editId:", frondData.editId);
    
//     setValue("title", frondData.editTitle || "");
//     setValue("category", frondData.editCategory || "");
//     setValue("desc", frondData.editDesc || "");
//     setValue("budget", frondData.editBudget || "");
//     setValue("currency", frondData.editCurrecy || "");
//     setValue("importance", frondData.editImportance || "");
//     setImportance(frondData.editImportance || "");

//     if (frondData.editStartDate || frondData.editEndDate) {
//       const dateRange = {};
      
//       if (frondData.editStartDate && Array.isArray(frondData.editStartDate) && frondData.editStartDate.length === 3) {
//         dateRange.start = parseDate(
//           `${frondData.editStartDate[2]}-${String(frondData.editStartDate[1]).padStart(
//             2,
//             "0"
//           )}-${String(frondData.editStartDate[0]).padStart(2, "0")}`
//         );
//       }
      
//       if (frondData.editEndDate && Array.isArray(frondData.editEndDate) && frondData.editEndDate.length === 3) {
//         dateRange.end = parseDate(
//           `${frondData.editEndDate[2]}-${String(frondData.editEndDate[1]).padStart(
//             2,
//             "0"
//           )}-${String(frondData.editEndDate[0]).padStart(2, "0")}`
//         );
//       }
      
//       if (Object.keys(dateRange).length > 0) {
//         setValue("dateRange", dateRange);
//       }
//     }

//     if (Array.isArray(frondData.editTags)) {
//       const processedTags = frondData.editTags
//         .map((tag, index) => ({
//           id: tag.name?.en || `tag-${index}-${Date.now()}`,
//           text: tag.name?.en || "",
//         }))
//         .filter((tag) => tag.text);

//       console.log("Setting processedTags:", processedTags);
//       setValue("tags", processedTags);
//       setTags(processedTags);
//     } else {
//       setValue("tags", []);
//       setTags([]);
//     }

//     if (frondData.editDesc) {
//       setDescLength(frondData.editDesc.length);
//     }
//   }
// }, [frondData, setValue]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isEditDetailsOpen]);

  useEffect(() => {
    if (isEditDetailsOpen) {
      handleResize();
    }
  }, [isEditDetailsOpen]);

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        handleResize();
      }, 1000);
    }
  }, [isModalOpen]);

  const { width } = useSize();

  if (width === 0) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onClose}
      placement="center"
      backdrop="opaque"
      classNames={{
        backdrop: "z-[9999]",
        wrapper: "z-[99999] overflow-hidden",
        footer: "justify-center items-center p-0 min-h-[60px]",
        body: "px-[30px] mb-2.5",
        closeButton: "hidden",
        base: "rounded-[20px] p-5",
      }}
    >
      <div>
        <ModalContent>
          {(closeModal) => (
            <>
              <ModalHeader className="flex justify-between gap-2.5 items-center p-0 pb-[15px] pt-[15px] sm:px-5 px-2.5 mb-[15px] relative after:absolute after:left-0 after:right-0 after:bottom-0 after:h-[0.5px] after:bg-grayBorder">
                <h3 className="text-lg text-textColor font-bold leading-[10.35px]">
                  Edit About
                </h3>
                <button onClick={closeModal} aria-label="Close">
                  <img src={closeIcon} alt="Close" className="w-6 h-6" />
                </button>
              </ModalHeader>
              <form onSubmit={handleSubmit(editFrond)}>
                <div className="max-h-[55vh] overflow-y-auto scroll-outter">
                  {isRefreshing ? (
  <ModalBody className="w-[100%] scroll-inner">
    <div className="flex justify-center items-center h-[200px]">
      <div className="text-center">
        <i className="fa-solid fa-spinner fa-spin text-3xl text-mainPink"></i>
        <p className="mt-4 text-gray-600">Updating your data...</p>
      </div>
    </div>
  </ModalBody>
) : (
                  <ModalBody className="w-[100%] scroll-inner">
                    <div className="flex flex-col gap-2.5">
                      <Controller
                        name="title"
                        control={control}
                        rules={{
                          required: "Title is required",
                          minLength: {
                            value: 3,
                            message: "Minimum number of characters is 3",
                          },
                          maxLength: {
                            value: 100,
                            message: "Maximum number of characters is 100",
                          },
                          validate: {
                            noTrailingSpace: (value) =>
                              !/\s$/.test(value) ||
                              "Title shouldn't end with a space",
                          },
                          pattern: {
                            value:
                              /^(?! )[a-zA-Z0-9\-\_\'\"\.\,\!\@\?\#\$\%\^\&\*\(\)\+\=\/\\\:]+(?!.*\s{2})[a-zA-Z0-9\-\/\\\_\'\:\"\.\,\!\@\#\$\%\^\&\*\(\)\+\= ]*$/gi,
                            message:
                              "Title may contain characters, numbers and special characters",
                          },
                        }}
                        render={({ field }) => (
                          <Input
                            onKeyDown={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                            {...field}
                            type="text"
                            variant="bordered"
                            label="Title"
                            placeholder="Title here..."
                            labelPlacement="outside"
                            classNames={{
                              base: `input-noMargin ${
                                errors.title?.message ? "h-[86px]" : "h-[68px]"
                              }`,
                              label:
                                "text-textColor font-normal phone:text-sm text-[10px]",
                              input:
                                "border-none px-[18px] phone:text-base text-[10px]",
                              mainWrapper: `${
                                errors.title?.message ? "h-[68px]" : "h-[42px]"
                              }`,
                              innerWrapper: "h-[42px]",
                              inputWrapper: `border-[0.86px] p-0 border-solid ${
                                errors.title?.message
                                  ? "invalid-text"
                                  : "border-[#E5E4EB]"
                              } rounded-[8px] h-[42px]`,
                            }}
                            isInvalid={errors.title?.message ? true : false}
                            errorMessage={errors.title?.message}
                          />
                        )}
                      />

                      <Controller
                        name="category"
                        control={control}
                        rules={{
                          required: "Category is required",
                        }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            variant="bordered"
                            label="Category"
                            labelPlacement="outside"
                            selectedKeys={field.value ? [field.value] : []}
                            placeholder="Select Category"
                            classNames={{
                              base: `input-noMargin ${
                                errors.category?.message
                                  ? "h-[96px]"
                                  : "h-[68px]"
                              } custom-input-value`,
                              label:
                                "text-textColor font-normal phone:text-sm text-[10px]",
                              mainWrapper: `${
                                errors.category?.message
                                  ? "h-[68px]"
                                  : "h-[42px]"
                              }`,
                              innerWrapper: "h-[42px] px-[18px]",
                              trigger: `p-0 h-[42px] border-[0.86px] border-solid ${
                                errors.location?.message
                                  ? "invalid-text"
                                  : "border-[#E5E4EB]"
                              } rounded-[8px] flex items-center justify-between`,
                              value:
                                "text-cardGrayColor phone:text-sm text-[10px] font-normal",
                              selectorIcon:
                                "phone:w-[18px] phone:h-[18px] w-[12px] h-[12px]",
                            }}
                            selectorIcon={<img src={up} />}
                            isInvalid={errors.category?.message ? true : false}
                            errorMessage={errors.category?.message}
                          >
                            {categories.map((item) => (
                              <SelectItem key={item}>{item}</SelectItem>
                            ))}
                          </Select>
                        )}
                      />

                      <div>
                        <Controller
                          name="desc"
                          control={control}
                          rules={{
                            minLength: {
                              value: 2,
                              message: "Minimum number of characters is 2",
                            },
                            maxLength: {
                              value: 1000,
                              message: "Maximum number of characters is 1000",
                            },
                          }}
                          render={({ field }) => (
                            <Textarea
                              {...field}
                              onInput={(e) =>
                                setDescLength(e.target.value.length)
                              }
                              variant="bordered"
                              maxLength={1000}
                              placeholder="Text here..."
                              labelPlacement="outside"
                              classNames={{
                                base: "input-noMargin",
                                label:
                                  "text-textColor font-normal phone:text-sm text-[10px]",
                                input:
                                  "px-[18px] py-[12px] border-none create-frond-desc phone:text-base text-[10px]",
                                innerWrapper: "p-0 min-h-[116px] max-h-[116px]",
                                inputWrapper: `border-[0.86px] p-0 border-solid ${
                                  errors.desc?.message
                                    ? "invalid-text"
                                    : descLength >= 1000
                                    ? "border-[#f31260]"
                                    : "border-[#E5E4EB]"
                                } rounded-[8px] min-h-[116px] max-h-[116px]`,
                              }}
                              label={
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: labelDescHtml,
                                  }}
                                />
                              }
                              isInvalid={errors.desc?.message ? true : false}
                              errorMessage={errors.desc?.message}
                            />
                          )}
                        />
                        {descLength >= 1000 ? (
                          <p className="text-[.75rem] text-[#f31260] mt-1 font-medium">
                            Maximum 1000 characters exceeded
                          </p>
                        ) : 1000 - descLength > 0 ? (
                          <p className="text-[.75rem] text-mainBlue mt-1">
                            {1000 - descLength} remaining characters
                          </p>
                        ) : null}
                      </div>

                      <Controller
                        name="dateRange"
                        control={control}
                        render={({ field }) => (
                          <DateRangePicker
                            {...field}
                            variant="bordered"
                            labelPlacement="outside"
                            visibleMonths={width >= 640 ? 2 : 1}
                            selectorIcon={
                              <Image
                                src={calendar}
                                className="w-[18px] h-[18px]"
                              />
                            }
                            label={
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: labelDateHtml,
                                }}
                              />
                            }
                            isInvalid={errors.dateRange?.message ? true : false}
                            errorMessage={errors.dateRange?.message}
                            classNames={{
                              base: `mt-0 min-h-[42px] max-h-[96px]`,
                              label:
                                "text-textColor font-normal phone:text-sm text-[10px]",
                              inputWrapper:
                                "border-[0.86px] p-0 border-solid border-[#E5E4EB] rounded-[8px] min-h-[42px] flex-row-reverse date-box",
                              innerWrapper: "px-[18px] h-full no-action",
                              segment:
                                "date-picker-frond phone:text-sm text-[10px] font-normal",
                              selectorButton:
                                "order-first phone:min-w-[18px] phone:max-h-[18px] phone:h-[18px] min-w-[12px] max-h-[12px] h-[12px] phone:me-1 me-[2px]",
                              separator:
                                "mx-0 date-picker-separator text-sm font-normal no-action",
                            }}
                          />
                        )}
                      />

                      <div className="flex items-start gap-2 sm:flex-nowrap flex-wrap">
                        <Controller
                          name="budget"
                          control={control}
                          rules={{
                            pattern: {
                              value: /^[1-9][0-9]*(\.[0-9]+)?$/,
                              message: "Invalid Budget",
                            },
                          }}
                          render={({ field }) => (
                            <Input
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              className="sm:min-w-[140px] sm:max-w-[140px] w-full"
                              {...field}
                              type="text"
                              variant="bordered"
                              placeholder="0"
                              labelPlacement="outside"
                              classNames={{
                                base: `input-noMargin ${
                                  errors.budget?.message ||
                                  errors.currency?.message
                                    ? "h-[96px]"
                                    : "h-[68px]"
                                }`,
                                label:
                                  "text-textColor font-normal phone:text-sm text-[10px]",
                                input:
                                  "border-none px-[18px] phone:text-base text-[10px]",
                                mainWrapper: `${
                                  errors.budget?.message ||
                                  errors.currency?.message
                                    ? "h-[68px]"
                                    : "h-[42px]"
                                }`,
                                innerWrapper: "h-[42px] px-[18px]",
                                inputWrapper: `border-[0.86px] p-0 border-solid ${
                                  errors.budget?.message
                                    ? "invalid-text"
                                    : "border-[#E5E4EB]"
                                } rounded-[8px] h-[42px]`,
                              }}
                              isInvalid={errors.budget?.message ? true : false}
                              errorMessage={errors.budget?.message}
                              startContent={
                                <Image
                                  src={euro}
                                  className="phone:min-w-[18px] phone:max-w-[18px] phone:h-[18px] min-w-[12px] max-w-[12px] h-[12px] phone:me-1 me-[2px]"
                                />
                              }
                              label={
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: labelBudgetHtml,
                                  }}
                                />
                              }
                            />
                          )}
                        />

                        <Controller
                          name="currency"
                          control={control}
                          render={({ field }) => (
                            <Select
                              className="w-[100%]"
                              {...field}
                              variant="bordered"
                              labelPlacement="outside"
                              selectedKeys={field.value ? [field.value] : []}
                              placeholder="Select Currency"
                              classNames={{
                                base: `input-noMargin ${
                                  errors.currency?.message ||
                                  errors.budget?.message
                                    ? "h-[96px]"
                                    : "h-[68px]"
                                } custom-input-value`,
                                label:
                                  "text-textColor font-normal phone:text-sm text-[10px]",
                                mainWrapper: `${
                                  errors.currency?.message ||
                                  errors.budget?.message
                                    ? "h-[68px]"
                                    : "h-[42px]"
                                }`,
                                innerWrapper: "h-[42px] px-[18px]",
                                trigger: `p-0 h-[42px] border-[0.86px] border-solid ${
                                  errors.currency?.message
                                    ? "invalid-text"
                                    : "border-[#E5E4EB]"
                                } rounded-[8px] flex items-center justify-between`,
                                value:
                                  "text-cardGrayColor phone:text-sm text-[10px] font-normal",
                                selectorIcon:
                                  "phone:w-[18px] phone:h-[18px] w-[12px] h-[12px]",
                              }}
                              selectorIcon={
                                <img
                                  src={up}
                                  className="phone:w-[18px] phone:h-[18px] w-[12px] h-[12px]"
                                />
                              }
                              isInvalid={
                                errors.currency?.message ? true : false
                              }
                              errorMessage={errors.currency?.message}
                              startContent={
                                <Image
                                  src={euro}
                                  className="phone:w-[18px] phone:h-[18px] w-[12px] h-[12px] phone:me-1 me-[2px]"
                                />
                              }
                              label={
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: labelCurrencyHtml,
                                  }}
                                />
                              }
                            >
                              {currenciesList.map((item) => (
                                <SelectItem key={item?.currency_code}>
                                  {item?.currency_code}
                                </SelectItem>
                              ))}
                            </Select>
                          )}
                        />
                      </div>

                      <Controller
                        name="tags"
                        control={control}
                        rules={{ validate: handleValidation }}
                        render={({ field }) => (
                          <div key={`tags-container-${tags.length}`}>
                            <label
                              className={`block ${
                                tagError ? "text-[#f31260]" : "text-textColor"
                              } phone:text-sm text-[10px] font-normal mb-2 transition-all duration-400`}
                              htmlFor="tags"
                            >
                              Tags{" "}
                              <span className="phone:text-xs text-[12px] text-cardGrayColor">
                                (Optional)
                              </span>
                            </label>
                            <ReactTags
                              autofocus={false}
                              id="tags"
                              tags={tags}
                              handleDelete={safeHandleDelete} 
                              handleAddition={handleAddition}
                              focusInputOnSelection={false} 
                              inputFieldPosition="bottom" 
                              editable={false}          
                              allowDragDrop={false}
                              separators={["Enter", "Comma"]}
                              placeholder="Add Tags ..."
                              maxTags={10}
                              removeComponent={({ index  }) => (
                                <span 
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    safeHandleDelete(index, e);
                                  }}
                                  className="cursor-pointer ml-1 text-white hover:text-gray-200"
                                  style={{ fontSize: '14px' }}
                                >
                                  ×
                                </span>
                              )}
                              classNames={{
                                tagInputField: `tagInputField bg-white border-[0.86px] mt-4 w-full px-[18px] border-solid phone:placeholder:text-base placeholder:text-[10px] ${
                                  tagError ? "invalid-text" : "border-[#E5E4EB]"
                                } rounded-[8px] h-[42px] placeholder: text-sm placeholder: font-normal phone:text-sm text-[12px] font-normal transition-all duration-400 no-focus`,
                                tag: `px-2.5 py-[6px] bg-[#1976D2] rounded-[20px] inline-flex text-white phone:text-sm text-[12px] items-center justify-center gap-1.5 mt-2 me-2`,
                                remove: "cursor-pointer ml-1 text-white hover:text-gray-200",
                              }}
                            />
                            {/* Hidden input for library's focus needs */}
                            <input 
                              type="text" 
                              id="tags-hidden-input"
                              style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
                              aria-hidden="true"
                              tabIndex={-1}
                            />
                            <style>{`
                              .ReactTags__tag[aria-disabled="true"] {
                                pointer-events: none;
                              }
                              .sr-only {
                                position: absolute;
                                width: 1px;
                                height: 1px;
                                padding: 0;
                                margin: -1px;
                                overflow: hidden;
                                clip: rect(0, 0, 0, 0);
                                white-space: nowrap;
                                border-width: 0;
                              }
                            `}</style>
                            {tagError && (
                              <p
                                className={`text-[#f31260] phone:text-xs text-[10px] mt-0.5 transition-opacity duration-400 ${
                                  tagError ? "opacity-100" : "opacity-0"
                                }`}
                              >
                                {tagError}
                              </p>
                            )}
                            {tagLimit && (
                              <p className="text-[#f31260] text-xs mt-1">
                                Tag limit reached (max 10)
                              </p>
                            )}
                          </div>
                        )}
                      />

                      <div className="flex flex-col justify-between">
                        <span className="text-textColor font-normal phone:text-sm text-[10px] mb-2">
                          Importance{" "}
                          <span className="phone:text-xs text-[10px] text-cardGrayColor">
                            (Optional)
                          </span>
                        </span>
                        <div className="flex gap-2 items-center h-[32px]">
                          <button
                            type="button"
                            className={`importanceBtn transition-all duration-300 phone:text-[15.54px] text-[12px] font-normal h-full w-1/3 rounded-l-[20px] flex justify-center items-center ${
                              importance === "High"
                                ? "bg-[#FF3D00E5] opacity-90 shadow-importanceShadow border-2 border-solid border-[#FF3D00E5]"
                                : "border-2 border-solid border-[#FF3D00E5]"
                            } `}
                            onClick={() => setImportance("High")}
                          >
                            <span
                              className={`transition-all duration-300 opacity-100 ${
                                importance === "High"
                                  ? "text-white"
                                  : "text-[#FF3D00E5]"
                              } `}
                            >
                              High
                            </span>
                          </button>
                          <button
                            type="button"
                            className={`importanceBtn transition-all duration-300 phone:text-[15.54px] text-[12px] font-normal h-full w-1/3 flex justify-center items-center ${
                              importance === "Medium"
                                ? "bg-[#FFC000] opacity-90 shadow-importanceShadow border-2 border-solid border-[#FFC000]"
                                : "border-2 border-solid border-[#FFC000]"
                            } `}
                            onClick={() => setImportance("Medium")}
                          >
                            <span
                              className={`transition-all duration-300 opacity-100 ${
                                importance === "Medium"
                                  ? "text-white"
                                  : "text-[#FFC000]"
                              } `}
                            >
                              Medium
                            </span>
                          </button>
                          <button
                            type="button"
                            className={`importanceBtn transition-all duration-300 phone:text-[15.54px] text-[12px] font-normal h-full w-1/3 rounded-r-[20px] flex justify-center items-center ${
                              importance === "Low"
                                ? "bg-[#5CCDB0] opacity-90 shadow-importanceShadow border-2 border-solid border-[#5CCDB0]"
                                : "border-2 border-solid border-[#5CCDB0]"
                            } `}
                            onClick={() => setImportance("Low")}
                          >
                            <span
                              className={`transition-all duration-300 opacity-100 ${
                                importance === "Low"
                                  ? "text-white"
                                  : "text-[#5CCDB0]"
                              } `}
                            >
                              Low
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ModalBody>
                  )}
                </div>
                <ModalFooter className="shadow-modalShadow min-h-[60px] max-h-[80px]">
                  <button
                    disabled={isDisabled}
                    type="submit"
                    className="text-base font-bold leading-[18.4px] text-white flex justify-center items-center bg-mainGradiant rounded-[27px] phone:py-[11px] py-[8px] px-[25px] sm:w-[234px] w-[117px] sm:min-h-[39px] sm:max-h-[39px] min-h-[30px] max-h-[30px]"
                  >
                    {isLoading ? (
                      <span className="flex justify-center items-center text-white">
                        <i className="fa-solid fa-spinner fa-spin"></i>
                      </span>
                    ) : (
                      "Save"
                    )}
                  </button>
                </ModalFooter>
              </form>
            </>
          )}
        </ModalContent>
      </div>
    </Modal>
  );
};

export default EditDetailsModal;